import { put, takeLatest, all, select } from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import { quotationLoaded } from './actions';
import {
  makeSelectQuotationCode,
  makeSelectProposalId,
  makeSelectQuotationStatus,
} from './selectors';
import {
  GET_QUOTATION,
  UPDATE_QUOTATION_STATUS,
} from './constants';
import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';

function* fetchQuotes() {
  const proposal_id = yield select(makeSelectProposalId());
  const requestURL = `${API_URL}proposals/${proposal_id}`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };

    const response = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    if (response && response.data) {
      yield put(quotationLoaded(response.data));
    } else {
      window.location = '/quotations';
    }
  } catch (err) {
    console.log('request error', err);
  }
}

function* updateStatus() {
  const code = yield select(makeSelectQuotationCode());
  const newStatus = yield select(makeSelectQuotationStatus());
  const requestURL = `${process.env.API_URL}quotations/${code}/status`;
  const requestBody = {
    status: newStatus,
  };

  try {
    const parameters = {
      method: 'PUT',
      headers: getRequestHeadersAsLogged(),
      body: JSON.stringify(requestBody),
    };

    yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );

    yield fetchQuotes();
  } catch (err) {
    console.log('request error', err);
  }
}

function* actionWatcher() {
  yield takeLatest(GET_QUOTATION, fetchQuotes);
  yield takeLatest(UPDATE_QUOTATION_STATUS, updateStatus);
}

export default function* quotationData() {
  yield all([actionWatcher()]);
}
